











































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Contact } from '@contacts/interfaces/contact';
import { ContactMergeData } from '@contacts/interfaces/contact-merge-data';
import { HideContactMergeFields } from '@contacts/interfaces/hide-contact-merge-fields';

@Component({
  name: 'bc-merge-contact-selector-fields',
  components: {},
})
export default class MergeContactSelectorFields extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly contact: Contact;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly selectedContactDataToMerge: ContactMergeData;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly hideFieldsList: HideContactMergeFields;
  @Prop({
    type: Boolean,
    default: false,
  })
  readonly disabled: boolean;

  get contactDataToMerge(): ContactMergeData {
    return this.selectedContactDataToMerge;
  }

  set contactDataToMerge(value: ContactMergeData) {
    this.$emit('data-changed', value);
  }

  get contactFullname(): string {
    return this.contact?.fullname || '';
  }
  get contactLanguage(): string {
    return this.contact?.language || '';
  }
  get contactFirstname(): string {
    return this.contact?.contact_individual?.firstname || '';
  }
  get contactLastname(): string {
    return this.contact?.contact_individual?.lastname || '';
  }
  get contactGender(): string {
    return this.contact?.contact_individual?.gender || '';
  }
  get contactBirthdate(): string {
    return this.contact?.contact_individual?.birthdate || '';
  }
  get contactFormattedBirthdate(): string {
    return this.$bpcHelper.formatDate(this.contact?.contact_individual?.birthdate);
  }
  get contactStreet(): string {
    return this.contact?.contact_detail?.street || '';
  }
  get contactStreet2(): string {
    return this.contact?.contact_detail?.street2 || '';
  }
  get contactZip(): string {
    return this.contact?.contact_detail?.zip || '';
  }
  get contactCity(): string {
    return this.contact?.contact_detail?.city || '';
  }
  get contactCountry(): string {
    return this.contact?.contact_detail?.country || '';
  }
  get contactPhone1(): string {
    return this.contact?.contact_detail?.phone1 || '';
  }
  get contactPhone2(): string {
    return this.contact?.contact_detail?.phone2 || '';
  }
  get contactPhone3(): string {
    return this.contact?.contact_detail?.phone3 || '';
  }
  get contactEmail1(): string {
    return this.contact?.contact_detail?.email1 || '';
  }
  get contactEmail2(): string {
    return this.contact?.contact_detail?.email2 || '';
  }
  get contactType(): string {
    return this.contact?.type_value || this.contact?.type;
  }
}
